import { useEffect, useState } from 'react';

export function useButtonsVisible() {
    const [ isButtonsVisible, setIsButtonVisible ] = useState(true);

    useEffect(() => {
        const screenSize = window.innerHeight * window.innerWidth;

        function handleResize() {
            const updatedScreenSize = window.innerHeight * window.innerWidth;

            setIsButtonVisible(updatedScreenSize >= screenSize);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [ setIsButtonVisible ]);

    return {
        isButtonsVisible
    };
}
